<template>
    <div class="column is-one-quarter left-side theme-style">
        <share-box v-bind:lot="lot"></share-box>
        <car-specs v-bind:lot="lot"></car-specs>
        <auc-info v-bind:lot="lot"></auc-info>
        <inland-cost v-bind:lot="lot"></inland-cost>

        <div class="other-section" v-if="isMobile">
            <translate-box v-bind:lot="lot"></translate-box>
            <comments-box v-bind:lot="lot"></comments-box>
        </div>
    </div>
</template>

<script>
    import CarSpecs from './Details/CarSpecs'
    import AucInfo from './Details/AucInfo'
    import ShareBox from './ShareBox.vue'
    import InlandCost from '../../Tools/Calculators/InlandCost.vue'
    import CommentsBox from './CommentsBox.vue'
    import TranslateBox from './Details/TranslationBox'
    export default {
        props: ['lot'],
        components: {
            carSpecs: CarSpecs,
            aucInfo: AucInfo,
            shareBox: ShareBox,
            InlandCost,
            commentsBox: CommentsBox,
            TranslateBox,
        },
        computed: {
            isMobile() {
                return document.documentElement.clientWidth < 450;
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Auctions/Lot/LeftSide.vue